import { api, client } from "@/client";
import { useAuthenticationStore } from "@/stores/authentication";
import { StorageSerializers, useStorage } from "@vueuse/core";
import { defineStore, acceptHMRUpdate } from "pinia";
import { Client } from "typesense";
import { ExportCsv } from "@/library/ExportCsv";
import moment from "moment";
import { stringify } from "querystring";

export const useTypesenseCSVStore = defineStore("typesense_csv", {
  state: () => ({
    loading: false,
    packageList: [] as any,
    aipDipDetails: [] as any,
    totalRecords: 0,
    test: {},
    key: "" as string,
    expiry: 0 as number,
    currentContent: {} as any,
    searchKey: null as api.KeysResponseBody | null,
    typesenseheader: "" as string | undefined,
    eventList: [] as any,
    fileList: [] as any,
    currentEvent: {} as any,
    currentFile: {} as any,
    csvList:[] as any,
    filename :"" as string,
  }),
  getters: {},
  actions: {
    async fetchTypesense(type, searchParameters,times,columns,report_type) {
      if (this.loading) return;
      this.loading = true;

      // console.log(searchParameters);
      
      const updateParams = (newProps: any) => {
        searchParameters = Object.assign({}, searchParameters, newProps);
      };
      updateParams({ per_page: 250 });

      const key = useStorage("search-api-keys", this.searchKey, undefined, {
        serializer: StorageSerializers.object,
      });
      const inOneMinute = Math.floor(Date.now() / 1000) + 60;
      if (!key.value || key.value.expiresAt < inOneMinute) {
        key.value = await client.search.searchKeys();
      }
      this.searchKey = key.value;
      // check type to select search key

      if (type != "secure-zone-downloads") {
        this.typesenseheader = this.searchKey?.packagesKey;
      } else {
        this.typesenseheader = this.searchKey?.downloadsKey;
      }

      const x = new Client({
        nodes: [
          {
            host: import.meta.env.VITE_TYPESENSE_ADDR,
            port: import.meta.env.VITE_TYPESENSE_PORT,
            path: import.meta.env.VITE_TYPESENSE_NAME,
            protocol: import.meta.env.VITE_PROTOCOL,
          },
        ],

        apiKey: String(this.typesenseheader),
        // apiKey: String("typesenseapikey"),
        connectionTimeoutSeconds: 20,
      });
      var i =0;
      this.csvList=[];
      var z= 0;
      for(i=1;i<=times;i++){
        updateParams({ page: i });
        x.collections(type)
        .documents()
        .search(searchParameters)
        .then((result: any) => {
          z++;
          this.reset();
          // if (type != "secure-zone-files") {
            this.totalRecords = result.found;
            for (let index = 0; index < result.hits.length; index++) {
              const element = result.hits[index].document;

              
              
               var new_transfer_date= moment.unix(result.hits[index].document.transfer_date).format("DD MMM yyyy");
               
              
              var size  = result.hits[index].document.size;
              var size_reuslt = '-';

              if (size >= 1073741824) {
                 size_reuslt= (size / 1073741824).toFixed(2) + " GB";
              } else  {
                size_reuslt = (size / 1048576).toFixed(2) + " MB";
              }


            
              if(result.hits[index].document.type == "DIP"){
                var rp = "Access";
              }else if (result.hits[index].document.type == "AIP"){
                var rp = "Master";
              }else {
                var rp = "-";
              }


              if(result.hits[index].document.representation == "Access"){
                var rp2 = "Access";
              }else if (result.hits[index].document.type == "Preservation"){
                var rp2 = "Master";
              }else {
                var rp2 = "-";
              }

              

              const element2 = {
                                uuid : result.hits[index].document.transfer_uuid,
                                transfferingAgency : result.hits[index].document.transfer_agency,
                                transfferingbatchNo : result.hits[index].document.transfer_batch,
                                trasnferDate : new_transfer_date,
                                dateReceived : result.hits[index].document.created_at,
                                ingestedDate : result.hits[index].document.date_of_ingestion,
                                representation : rp,
                                securityGrading : result.hits[index].document.security_grading,
                                sensitivityClassification : result.hits[index].document.sensitivity_classification,
                                noofcomputerFiles : result.hits[index].document.files_count,
                                } ;
              const element3 = {
                                uuid : result.hits[index].document.transfer_uuid,
                                itemId : result.hits[index].document.item_id,
                                itemTitle : result.hits[index].document.item_title,
                                ingestedDate : result.hits[index].document.date_of_ingestion,
                                trasnferDate : new_transfer_date,
                                transfferingAgency : result.hits[index].document.transfer_agency,
                                securityGrading : result.hits[index].document.security_grading,
                                sensitivityClassification : result.hits[index].document.sensitivity_classification,
                                representation : rp2,
                                fileformat : result.hits[index].document.format,
                                filesize : size_reuslt,
                                } ;
                                




              
              // to add new element to disable checkbox base on selectd field
              // if (element.status === "Reingesting")
              //   element.checkboxDisabled = true;
              this.packageList.push(element);
                       
              if (report_type == "InfoPackages"){
                this.csvList.push(element2)
                this.filename = "Information Packages Ingested Report";
              }else if (report_type == "FileFormat"){
                this.csvList.push(element3)
                this.filename = "File Format Report";
              }
              
            }
            this.currentContent = this.packageList[0];
              // console.log("cweyuh",this.csvList);
            //  throw new Error("my error message");
               result = this.csvList;
               if(z== times){
                ExportCsv.exportFile( this.filename + ".csv", this.csvList, columns);
                this.loading = false;
              }
          // }
        })
        .catch(() => {
          this.loading = false;
        });
     
        
      };

    },
    fetchCurrent(params: any) {
      this.$reset;
      this.currentContent = params.row;
    },
    removeSearchKeys() {
      const keys = useStorage("search-api-keys", this.searchKey, undefined, {
        serializer: StorageSerializers.object,
      });
      this.searchKey = keys.value = null;
    },



    confirm(locationName: string) {},
    reject() {},
    reset() {
      this.packageList = [];
      this.removeSearchKeys();
    },
  },
});
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useTypesenseCSVStore, import.meta.hot));
}
